import React from 'react'
import Footer from '../components/Footer'
import Landing from '../components/Landing'
import Projects from '../components/Projects'

export default function Home() {
  return (
    <>
    <Landing />
    <Projects />
    <Footer />
    </>
  )
}
